
@if (dto) {
  <div class="header">
    <app-user-avatar-circle class="avatar" [fullName]="dto.FirstName + ' ' + dto.LastName"></app-user-avatar-circle>
    <div class="agreement-details-container">
      <h3 class="header__name">{{ dto.FirstName }} {{ dto.LastName }}</h3>
      <span class="header__details_row">
        <span class="name">{{ 'EDocumentDetails.Pesel' | translate }}: </span>{{dto.Pesel}}
      </span>
      <span class="header__details_row">
        <span class="name"> {{ 'EDocumentDetails.Company' | translate }}: </span>{{dto.CompanyName}}
      </span>
      <span class="header__details_row">
        <span class="name">{{ 'EDocumentDetails.AddedDate' | translate }}: </span>{{ dto.AddedDate | date: 'yyyy-MM-dd' }}
      </span>
      @if (dto.ValidUntilDate) {
        <span class="header__details_row">
          <span class="name">{{ 'EDocumentDetails.ValidUntilDate' | translate }}: </span>{{ dto.ValidUntilDate | date: 'yyyy-MM-dd' }}
        </span>
      }
      @if (dto.IsSigned) {
        <span class="header__details_row">
          <span class="name">{{ 'EDocumentDetails.SignedDate' | translate }}: </span>{{ dto.AddedDate | date: 'yyyy-MM-dd' }}
        </span>
      }
      <span class="header__details_row">
        <span class="name">{{ 'EDocumentDetails.DocumentPart' | translate }}: </span>{{ dto.DocumentPart }}
      </span>
      <span class="header__details_row">
        <span class="name">{{ 'EDocumentDetails.DocumentType' | translate }}: </span>{{ dto.DocumentType }}
      </span>
    </div>
    <div class="paycheck-container">
      <div class="paycheck-item">
        <span class="name">{{ 'EDocumentDetails.DocumentName' | translate }}</span>
        <span class="value">{{dto.DocumentName}}</span>
      </div>
      <div class="paycheck-item">
        <span class="name">{{ 'EDocumentDetails.DocumentId' | translate }}</span>
        <span class="value">{{dto.DocumentId}}</span>
      </div>
    </div>
  </div>
  <div class="content">
    @if (dto.Comments) {
      <div class="content-wrapper">
        <span class="name">{{ 'EDocumentDetails.Comments' | translate}}</span>
        <span class="value">{{ dto.Comments }}</span>
      </div>
    }
    <div class="content-wrapper">
      <span class="name">{{ 'EDocumentDetails.File' | translate}}</span>
      <a class="value" (click)="onPreviewFileBtnClick()">{{ dto.OriginalFileName }}</a>
    </div>
    <div class="content-wrapper">
      <span class="name">{{ 'EDocumentDetails.FileContent' | translate}}</span>
      <div class="content-wrapper">
        <ng-container
          [ngTemplateOutlet]="fileContentsTable"
          [ngTemplateOutletContext]="{fileContents: dto.FileContents}">
        </ng-container>
      </div>
    </div>
  </div>
  <div class="footer">
    <button mat-raised-button color="primary" mat-dialog-close>{{ 'settlement-details.close' | translate }}</button>
  </div>
}

<ng-template #fileContentsTable let-fileContents='fileContents'>
  <mat-table #table class="settlement-table" [dataSource]="fileContents">
    <ng-container matColumnDef="key">
      <mat-cell *matCellDef="let element">{{ element.Key }}</mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="value">
      <mat-cell *matCellDef="let element">{{ element.Value }}</mat-cell>
      <mat-footer-cell *matFooterCellDef></mat-footer-cell>
    </ng-container>

    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    <mat-footer-row *matFooterRowDef="displayedColumns"></mat-footer-row>
  </mat-table>
</ng-template>